import { render, staticRenderFns } from "./templateSMS.vue?vue&type=template&id=79f7b70b&scoped=true&"
import script from "./templateSMS.vue?vue&type=script&lang=js&"
export * from "./templateSMS.vue?vue&type=script&lang=js&"
import style0 from "./templateSMS.vue?vue&type=style&index=0&id=79f7b70b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f7b70b",
  null
  
)

export default component.exports